// Web Component: ThemeSlider
// Descrizione: Gestisce uno slider di valori numerici con etichette, range e step configurabili tramite attributi custom.
// Attributi accettati:
//   - data-labels: selettori CSS delle etichette da aggiornare
//   - data-values: valori iniziali dello slider (array)
//   - data-min: valore minimo
//   - data-max: valore massimo
//   - data-step: step dello slider
//   - data-decimals: numero di decimali da mostrare
//   - data-format: formato di visualizzazione delle etichette
// Eventi emessi:
//   - Utils.E_SLIDER_CHANGE: emesso al cambio valore
// Dipendenze: noUiSlider, presenza di input e label
// Limiti: richiede struttura HTML compatibile e presenza di noUiSlider
// Utilizzo: usato per filtri e selezione valori numerici (es. filtri prezzo)
class ThemeSlider extends HTMLElement {
  labels = []; inputs; values; min; max; step; decimals;
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
    if(this.dataset.labels !== undefined){
      const labels = this.dataset.labels.split(',');
      labels.forEach(label => {
        const labelElement = document.querySelector(label);
        if(labelElement !== null){
          this.labels.push(labelElement);
        }
      });
    }
    this.decimals = this.dataset.decimals !== undefined ? parseInt(this.dataset.decimals) : 0;

    this.inputs = this.querySelectorAll('input');
    const values = this.dataset.values.split(',');
    this.values = values.map(value => parseInt(value));

    this.min = parseInt(this.dataset.min);
    this.max = parseInt(this.dataset.max);
    this.step = this.dataset.step == undefined ? 1 : parseInt(this.dataset.step);
    
    noUiSlider.create(this, {
      start: this.values,
      connect: true,
      range: {
        'min': this.min,
        'max': this.max
      },
      step: this.step
    });

    // Aggiungi aria-labelledby agli handle generati da noUiSlider
    if (this.dataset.ariaLabels) {
      const ariaLabels = this.dataset.ariaLabels.split(',');
      const handles = this.querySelectorAll('.noUi-handle');
      handles.forEach((handle, index) => {
        const labelId = ariaLabels[index]?.replace('#', '');
        if (labelId) handle.setAttribute('aria-labelledby', labelId);
      });
    }

    this.noUiSlider.on('update', (values) => {
      this.setValues(values);
    }); 

    this.noUiSlider.on('change', (values) => {
      this.setInputs(values);
      this.dispatchEvent(new CustomEvent(Utils.E_SLIDER_CHANGE, { detail: this.values }));
    });
  }

  setInputs = (values) => {
    this.values = values;
    this.inputs.forEach((input, index) => {
      input.value = (Number(this.values[index]) / 100).toFixed(this.decimals);
    });
  }

  setValues = (values) => {
    this.values = values;
    this.setLabels();
  }

  setLabels = () => {
    if(this.labels.length > 0){
      this.labels.forEach((label, index) => {
        label.innerHTML = this.format(this.values[index]);
      });
    }
  }

  format = (value) => {
    const format = this.dataset.format || '{label}';
    if(format == 'money')
      return Utils.money(value);
    else
      return format.replaceAll('{label}', value);
  }

  getInputs = () => {
    return this.inputs;
  }
  
}
if (!window.customElements.get("theme-slider")) {
  window.customElements.define("theme-slider", ThemeSlider);
}